import PhoneInput from "components/atoms/PhoneInput";
import { useEffect, useState } from "react";
import  i18next  from 'i18next';

export default function PhoneInputRedux({
	id,
	input,
	label,
	handleBlur,
	handleFocus,
	PhoneInputProps,
	className,
	meta: { error, touched, invalid },
}: any) {

	const [cError , setCError] = useState(i18next.t(`${error}`));
	const [currentLanguage,setCurrlang]=useState(i18next.language);

	

	if(currentLanguage !== i18next.language){
		setCurrlang(i18next.language)
	}
	useEffect(()=>{
		setCError(i18next.t(`${error}`));
	},[error,currentLanguage])


	return (
		<PhoneInput
			{...PhoneInputProps}
			className={className}
			id={id}
			name={input?.name}
			specialLabel={label}
			value={input?.value?.value}
			helperText={touched && invalid && cError}
			error={touched && invalid && error && true}
			onBlur={(e) => {
				handleBlur?.(e);
				e.preventDefault();
			}}
			onFocus={(e) => {
				handleFocus?.(e);
				e.preventDefault();
			}}
			onChange={(value, data, _e, formattedValue) => {
				input.onChange({ value, data, formattedValue });
			}}
		/>
	);
}
